import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../analytics';
import '../PortfolioV2.css';

const services = [
  ['Créer', 'Site vitrine, page de présentation ou boutique pour montrer votre activité et recevoir des demandes de clients ou des ventes.', '/services/creation-site-web'],
  ['Simplifier', 'Permettre aux clients de prendre rendez-vous sur votre site, payer une prestation ou demander un devis ; centraliser ensuite commandes et informations.', '/services/reservation-paiement-backoffice'],
  ['Reprendre', 'Projet commencé avec une IA, du no-code ou un autre développeur, puis bloqué avant la mise en ligne.', '/services/reprise-projet-web'],
];

export default function DeveloppeurWebFrance() {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute('content');

    document.title = 'Développeur web freelance en France | Alioune Seck';
    description?.setAttribute(
      'content',
      'Développeur web freelance disponible partout en France : sites sur mesure, rendez-vous pris par vos clients sur votre site, outils de gestion et reprise de projets.'
    );
    trackEvent('acquisition_page_view', { page_type: 'national', location: 'france' });

    return () => {
      document.title = previousTitle;
      if (description && previousDescription) description.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="portfolio-v2 acquisition-page-v2">
      <header className="estimator-page-header">
        <Link className="v2-brand" to="/">
          <span className="v2-brand-symbol">AS</span>
          <span><strong>Alioune Seck</strong><small>France · À distance</small></span>
        </Link>
        <Link
          className="v2-header-cta"
          to="/estimer-mon-projet"
          onClick={() => trackEvent('cta_click', { placement: 'france_header', target: 'estimator' })}
        >
          Estimer mon projet ↗
        </Link>
      </header>

      <main className="acquisition-main">
        <section className="acquisition-hero acquisition-local-hero">
          <span className="v2-kicker">Basé à Quimper · Projets partout en France</span>
          <h1>Développeur web freelance à distance, partout en France.</h1>
          <p>
            Je travaille avec des indépendants et petites entreprises sans imposer de proximité géographique.
            Le cadrage, les échanges et le suivi peuvent se faire à distance, avec des déplacements ponctuels
            lorsque le projet le justifie.
          </p>
          <div className="v2-hero-actions">
            <Link
              className="v2-primary"
              to="/estimer-mon-projet"
              onClick={() => trackEvent('cta_click', { placement: 'france_hero', target: 'estimator' })}
            >
              Estimer mon projet →
            </Link>
            <Link className="v2-secondary" to="/#contact">Me parler du besoin</Link>
          </div>
        </section>

        <section className="acquisition-local-intro">
          <span className="v2-kicker">Pas besoin d’être dans la même ville</span>
          <h2>Le développement web se pilote très bien à distance.</h2>
          <p>
            Pour la plupart des missions, une bonne visio, des retours clairs et un périmètre bien défini suffisent.
            Pour un projet qui mérite un atelier en présentiel ou une journée de cadrage, je peux aussi me déplacer
            ponctuellement, notamment vers Rennes, Nantes ou Paris.
          </p>
        </section>

        <section className="acquisition-service-grid">
          {services.map(([title, text, href], index) => (
            <article key={title}>
              <span>0{index + 1}</span>
              <h2>{title}</h2>
              <p>{text}</p>
              <Link className="v2-inline-cta" to={href}>Voir ce besoin →</Link>
            </article>
          ))}
        </section>

        <section className="acquisition-budget">
          <div>
            <span className="v2-kicker">Organisation</span>
            <h2>Un seul interlocuteur, où que soit votre entreprise.</h2>
          </div>
          <p>
            Les rendez-vous peuvent se faire en visio et les validations à distance. Si une présence sur place apporte
            une vraie valeur au projet, le déplacement est organisé en amont et intégré au cadrage.
          </p>
        </section>

        <section className="acquisition-convert">
          <span className="v2-kicker">Votre projet</span>
          <h2>Commencez par le besoin, pas par la ville.</h2>
          <p>
            Le simulateur vous aide à choisir les fonctions utiles et à obtenir un premier ordre de grandeur du budget
            et du délai avant un échange.
          </p>
          <Link
            className="v2-primary"
            to="/estimer-mon-projet"
            onClick={() => trackEvent('cta_click', { placement: 'france_bottom', target: 'estimator' })}
          >
            Faire une estimation →
          </Link>
        </section>
      </main>
    </div>
  );
}
